import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Loader from '../../utils/Loader';
import ContinueCourseBtn from './continueCourseBtn';
import Config from '../../config/Config';
import Zoom from '../utils/animations/zoom';
import MenuAnimation from '../utils/animations/menu';
const StatusSideBar = ({
	totalAttempts,
	completedPercent,
	completedElements,
	isCoachCourse,
	courseType,
	previewMode,
}) => {
	useEffect(() => {
		Loader.hide();
	}, []);

	return !!previewMode ? null : (
		<MenuAnimation className="db-right  dash-right-bar-width d-none d-lg-block d-xl-block">
			<span className="main-score-info">
				<div className="your_progress_title">Your Progress</div>
			</span>
			<div className="dash-step-score main-score">
				{!isCoachCourse ? (
					<div className="d-flex flex-column justify-content-center align-items-center">
						<div
							className="easypiechart-course-progress"
							id="easypiechart-course-expand"
							data-percent={(12 * completedPercent) / 100}
						>
							<span className="percent">
								<img src={Config.ASSETSPATH + '/img/step-elogo.png'} alt="Reading" />
							</span>
						</div>
						<div className="progress_percentage ">
							{completedPercent}% Complete <br />
							{completedElements} of {totalAttempts}{' '}
							{courseType === 'live' ? 'classes' : 'activities'} completed
						</div>
						{completedPercent !== 100 && (
							<Zoom>
								<ContinueCourseBtn />{' '}
							</Zoom>
						)}
					</div>
				) : (
					<div>
						<div
							className="easypiechart-course-progress"
							id="easypiechart-course-expand"
							data-percent={(12 * completedPercent) / 100}
						>
							<span className="percent">
								<img src={Config.ASSETSPATH + '/img/step-elogo.png'} alt="Reading" />
							</span>
						</div>
						<div className="progress_percentage ">
							{completedPercent}% Complete <br />
							{completedElements} of {totalAttempts}{' '}
							{courseType === 'time_based_coach' ? 'days left' : 'calls done'}
						</div>
					</div>
				)}
			</div>
		</MenuAnimation>
	);
};

const mapStateToProps = (state) => {
	const {
		totalAttempts,
		completedPercent,
		completedElements,
		continueElementDetails,
		isCoachCourse,
		description,
		video,
		domain,
		learningOutcomes,
		courseType,
		imageUrl,
		previewMode,
	} = state.rootReducer.myCourse;
	return {
		score: state.rootReducer.myStepDetails.score,
		isRetail: state.rootReducer.loginDetails.isRetail,
		totalAttempts,
		completedPercent,
		completedElements,
		continueElementDetails,
		isCoachCourse,
		description,
		video,
		domain,
		learningOutcomes,
		courseType,
		imageUrl,
		previewMode,
	};
};

export default withRouter(compose(connect(mapStateToProps))(StatusSideBar));
